import {
  GetRequest,
  DeleteRequest,
  PostRequestJson,
  PutRequestJson,
} from "src/shared/api";
import { config } from "src/config/config";

export const createBrandAPI = (options: any) => {
  const url: string = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.create_brand}`;
  let data: Record<string, any> = {
    name: options.name,
    account: options.account,
    hero_image: options.hero_image,
    description: options.description,
    kids: options.kids,
  };

  return PostRequestJson(url, data, {});
};

export const getBrandsByUserAPI = () => {
  const url: string = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.brands}`;

  return GetRequest(url, null, {});
};

export const getBrandDetailsAPI = (options: any) => {
  const url: string = `${
    config.MARKETPLACE_API.HOST
  }${config.MARKETPLACE_API.APIS_V2.brand(options.account)}`;

  return GetRequest(url, null, {});
};

export const updateBrandAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.update_brand}`;
  const data: Record<string, any> = {
    id: options.brandID,
    name: options.name,
    account: options.account,
    hero_image: options.hero_image,
    description: options.description,
    kids: options.kids,
  };
  return PutRequestJson(url, data, {});
};

export const getCreatedAssetsByUserAPI = (options: any) => {
  const url: string = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.brand_created_assets}`;
  const data = { brand_id: options.brandId };

  return GetRequest(url, data, {});
};
